// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"4aa6aba7","368":"26519623"}[chunkId] + ".chunk.js";
};